import icon from "../../assets/dimensions.svg";
import type { Property } from "../../types";

export const dimensions: Property = {
  id: "dimensions",
  title: "dimensions.title",
  icon,
};
